import * as XLSX from 'xlsx';

function flattenObject(obj:Record<any, any>, parent = '', res:Record<string, string> = {}) {
    for (let key in obj) {
        let propName = parent ? `${parent}.${key}` : key;
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            flattenObject(obj[key], propName, res);
        } else {
            res[propName] = obj[key];
        }
    }
    return res;
}

function transformTableData(tableData: any[], columns: string[], columnAlias?: { [key: string]: string }, allowedNested = false, columnTypes?: { [key: string]: string }): any[] {
    let transformedData = [];
    if(allowedNested) {
        transformedData = tableData.map(row => {
            const item = flattenObject(row)
            const newRow: { [key: string]: any } = {};
            Object.keys(item).forEach(col => {
                const columnName = columnAlias?.[col] || col;
                // Format date values
                if (columnTypes?.[col] === 'date' && item[col] != null) {
                    newRow[columnName] = formatDateValue(item[col]);
                } else if (columnTypes?.[col] === 'boolean') {
                    newRow[columnName] = !!item[col];
                } else {
                    newRow[columnName] = item[col] ?? '';
                }
            });
            return newRow;
        });
    } else {
        transformedData = tableData.map(row => {
            const newRow: { [key: string]: any } = {};
            columns.forEach(col => {
                const columnName = columnAlias?.[col] || col;
                // Format date values
                if (columnTypes?.[col] === 'date' && row[col] != null) {
                    newRow[columnName] = formatDateValue(row[col]);
                } else if (columnTypes?.[col] === 'boolean') {
                    newRow[columnName] = !!row[col];
                } else {
                    const value = row[col];
                    newRow[columnName] = value != null ? (typeof value === 'object' ? JSON.stringify(value) : value) : '';
                }
            });
            return newRow;
        });
    }
    return transformedData;
}

export function exportTableAsCSV(fileName: string, tableData: any[], columns: string[], columnAlias?: { [key: string]: string }, allowedNested = false, columnTypes?: { [key: string]: string }): void {
    const transformedData = transformTableData(tableData, columns, columnAlias, allowedNested, columnTypes);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transformedData);
    const csvContent = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveFile(blob, fileName, 'csv');
}
    
export function exportTableAsExcel(fileName: string, tableData: any[], columns: string[], columnAlias?: { [key: string]: string }, allowedNested = false, columnTypes?: { [key: string]: string }): void {
    const transformedData = transformTableData(tableData, columns, columnAlias, allowedNested, columnTypes);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAsExcelFile(excelBuffer, fileName);
}

function formatDateValue(value: any): string {
    try {
        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) return String(value);
        
        return date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    } catch (error) {
        return String(value);
    }
}

function saveFile(data: Blob, fileName: string, extension: string): void {
    const link = document.createElement('a');
    const url = URL.createObjectURL(data);
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}.${extension}`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveFile(data, fileName, 'xlsx');
}